"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirstPersonDisplay = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FirstPersonDisplay = /*#__PURE__*/_react["default"].memo(function () {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      position: "relative",
      overflow: "hidden",
      w: "37.5rem",
      maxWidth: "80%",
      h: "100%",
      r: "$3",
      m: "0 auto",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat"
    },
    "data-testid": "first_person_img",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      direction: "column",
      css: {
        position: "absolute",
        w: "100%",
        top: "33.33%",
        left: 0,
        textAlign: "center"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        color: "white",
        variant: "h4",
        css: {
          "@md": {
            fontSize: "$md"
          }
        },
        children: "Welcome!"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        color: "white",
        variant: "h6",
        css: {
          mt: "$4",
          "@md": {
            fontSize: "$sm"
          }
        },
        children: "You\u2019re the first one here."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        color: "white",
        variant: "h6",
        css: {
          mt: "$2",
          "@md": {
            fontSize: "$sm"
          }
        },
        children: "Sit back and relax till the others join."
      })]
    })
  });
});
exports.FirstPersonDisplay = FirstPersonDisplay;